import { render, staticRenderFns } from "./VectorTopBarIcon.vue?vue&type=template&id=7b4c8ab6&"
import script from "./VectorTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./VectorTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports